/**
 * Created by JMC on 13/10/19.
 */

export class IssueTagTotals {
    softwareTotal: number = 0;
    hardwareTotal: number = 0;
    wifiTotal: number = 0;
    installationTotal: number = 0;
    generalQuestionsTotal: number = 0;
    untaggedTotal: number = 0;
}
  




  